
import React, {useEffect, useMemo, useState} from 'react';
import { Helmet } from "react-helmet";
import {
    Link, useLocation,
} from "react-router-dom";
import { NavHashLink } from 'react-router-hash-link';

import appScreenshot from '../../assets/images/payroll.png';

import { connect } from 'react-redux';
import { Actions as CREATEACCOUNTACTIONS } from 'store/actions/createAccountActions';
import { Actions as WEBINARACTIONS } from 'store/actions/webinarActions';
import Team from 'components/team/Team'
import DarkScreenshotRight from '../uk/for/DarkScreenshotRight'
import LightScreenshotLeft from '../uk/for/LightScreenshotLeft'
import Security from 'components/security/Security'
import RegistrationForm from 'components/common/RegistrationForm'

import { format, addMinutes } from "date-fns";

import Vimeo from '@u-wave/react-vimeo';
import ReactPixel from 'react-facebook-pixel';
// import AddToCalendar from 'react-add-to-calendar';
import AddToCalendarHOC from 'react-add-to-calendar-hoc';

import 'react-add-to-calendar/dist/react-add-to-calendar.css'
import { CheckIcon, XMarkIcon, CalendarDaysIcon, GlobeEuropeAfricaIcon, CurrencyPoundIcon, UserGroupIcon, ShieldCheckIcon, ScaleIcon, ArrowsRightLeftIcon } from '@heroicons/react/24/outline'

import {
    CalculatorIcon,
    CalendarIcon,
    CloudArrowUpIcon,
    LockClosedIcon,
    ServerIcon,
    CheckCircleIcon,
    UserCircleIcon,
    MapPinIcon,
    ClipboardDocumentCheckIcon,
    DevicePhoneMobileIcon,
    ClockIcon,
    ChartBarIcon,
    CreditCardIcon,
    DocumentChartBarIcon,
    CloudIcon,
    CogIcon,
    ListBulletIcon,
    ShieldCheckIcon as ShieldCheckIconSolid, DocumentIcon, ChartPieIcon,
} from '@heroicons/react/20/solid'


import { Disclosure } from '@headlessui/react'
import { ChevronDownIcon } from '@heroicons/react/24/outline'
import SeoHeaders from "../../components/SeoHeaders";

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

const title = "Cloud Payroll & HR Software for Employers",
    intro = "Did you know 44% of employees consider resigning over incorrect pay? Don't leave your payroll up to chance work with Buddy and our payroll service provider network.",
    introCta = "Discover how Buddy can transform your payroll operations today.",
    description = "UK Payroll has never been easier. With Buddy's cloud UK Payroll Software, you can get payroll done quickly and efficiently."
// intro: "Rediscover the Joy of Payroll",

const painpoints = [
    {
        icon: <GlobeEuropeAfricaIcon className="h-6 w-6 text-white"/> ,
        name: 'Holistic Approach',
        description: "We view payroll as a collaborative process, involving multiple stakeholders. Buddy is designed to cater to each one's unique needs.",
    },
    {
        icon: <ArrowsRightLeftIcon className="h-6 w-6 text-white"/> ,
        name: 'Seamless Integrations',
        description: 'From accounting software to pension providers, our integrations ensure seamless operations.',
    },
    {
        icon: <UserGroupIcon className="h-6 w-6 text-white"/> ,
        name: 'User-Centric Design',
        description: "Whether you're an employee checking your payslip or a manager approving holidays, our platform is intuitive and user-friendly.",
    },
    {
        icon: <ShieldCheckIcon className="h-6 w-6 text-white"/> ,
        name: 'Unwavering Security',
        description: "Your data's safety is our top priority. With rigorous security measures, we ensure peace of mind.",
    },
]

const notfor = [
    "Employers who don't have a clue what they pay their employees",
    "Business Professionals who are happy to spend time on low-value tasks",
    "Business Professionals who don't care if salaries are issued correctly",
    "Business Professionals would rather slave themselves at night or on weekends instead of spending time with their loved ones",
]

const faqs = [
    {
        question: "How long does it take to implement Buddy, including the migration of existing clients?",
        answer:
            "Migration times can vary depending on the complexity of your data and the number of clients you have. For small bureaus it is usually a matter of hours or days, for larger bureaus much will depend on the quality of the data available from your current system and the availability of your team to assist with the migration. We have a team of experts who can help you with the migration process, reach out to our team so we can give a better indication based on your unique circumstances.",
    },
    {
        question: "What is the pricing model for Buddy?",
        answer:
            <>Buddy's pricing can be found in detail on the <Link to={"payroll-bureau/pricing"}>payroll bureau pricing page</Link>. These prices exclusively for qualified professionals with a registered institute who are offering a payroll service.</>,
    },
    {
        question: "What type of training and onboarding support does Buddy offer to new users?",
        answer:
            "We offer a range of training and onboarding options to suit your needs. From self-service resources to one-on-one training sessions, we're here to help you get up and running with Buddy as quickly as possible. Reach out to our team to discuss your requirements in more detail.",
    },
    {
        question: "Does Buddy integrate with other software?",
        answer:
            "Yes, Buddy integrates with a range of popular accounting software, HR systems, and other tools to streamline your payroll processes. You can view more information on our integrations page. If you have a specific integration in mind, reach out to our team to discuss your requirements.",
    },
    {
        question: "How frequently is the software updated to ensure compliance with the latest payroll regulations?",
        answer: "Buddy is updated regularly to ensure compliance with the latest payroll regulations. Our team closely monitors changes to legislation and updates the software accordingly. You can rest assured that Buddy will keep you compliant with the latest requirements.",
    },
    {
        question: "How are these updates managed and communicated to the users?",
        answer: "Our customer success team sends out an email to all our customers as soon as updates are completed, furthermore we also provide in-app notifications that would link to the detailed release notes.",
    },
    {
        question: "Can you provide more details on how multi-factor authentication is implemented?",
        answer: "Multi-factor authentication is a feature that can be enabled for the bureau and per client. This requires each user to set up their unique token using a device such as their phone by scanning a QR code on their first login. This ensures that even if a user's password is compromised, their account remains secure.",
    },
    {
        question: "Why is data stored in UK & EU Data Centers?",
        answer: "As part of our ISO27001 Audits we had identified an inherent risk in storing your data in a single region. Given the sensitivity of the data we store, we have decided to store your data in both the UK and EU data centers. This ensures that in case of a disaster we can recover your data from a different region.",
    },
    {
        question: "Can my data be stored only in the UK?",
        answer: "Given that the UK's data protection laws are now aligned with the EU's GDPR. We feel that the benefit of having your data stored in both the UK and EU data centers outweighs the risk of storing it in a single region. Furthermore, this restriction could also mean that certain features within Buddy would not otherwise be available. If you are an enterprise customer and this is something your IT team will not budge on please talk to us to discuss options.",
    },
    {
        question: "What is the historical uptime of the Buddy system?",
        answer: "Given that Buddy uses a serverless, or cloud-native architecture, we have a 99.99% uptime. This means that the system is available 99.99% of the time, with the remaining 0.01% being reserved for maintenance and updates. Due to the nature of the cloud, we are able to deploy the large majority of updates without any downtime.",
    },
    {
        question: "How does Buddy handle system outages or disruptions, especially during critical payroll processing periods?",
        answer: "In the unlikely event of a system outage, our team is on hand to resolve the issue as quickly as possible. We have a dedicated team of engineers who monitor the system and are alerted to any issues immediately. We also have a disaster recovery plan in place to ensure that your data is safe and secure.",
    },
    {
        question: "How customizable are the payroll and reporting features in Buddy?",
        answer: "Our standard reports are all generated using our reporting engine. You can use our custom report builder to choose which fields you would like in any new report.",
    },
    {
        question: "What level of access do clients have within the system?",
        answer: "By default clients will have no access to the system. While employees will only get access to their payslips. You are then able to invite users and provide distinct permissions. Most commonly clients are given access to employee data, payroll data entry and approval, reports as well as holiday management.",
    },
    {
        question: "How well does Buddy scale with the growth of a payroll bureau?",
        answer: "Buddy is designed to scale with your business. Whether you're a small bureau or a large enterprise, Buddy can handle your payroll needs. Our cloud-native architecture ensures that the system can grow with your business, providing the flexibility and scalability you need.",
    },
    {
        question: "What are the limitations, if any, in terms of processing capacity or client numbers?",
        answer: "Buddy is designed to handle a large number of clients and employees. Our largest single employer currently employs thousands of people. When dealing with single entities that have large numbers of employees generation of multi-page PDF reports may take proportionally longer. You are however notified when these are complete so you can continue working on something else.",
    },


    // More questions...
]

const forBlocks = [
    {
        for: "Team",
        title: "Effective Collaboration",
        backgroundColor: "employer",
        textColor: "employer",
        description: "Payroll is a team effort, your employees, managers and HR team need to be in sync for payroll to work correctly.",
        mobileImage: {
            src: 'assets/images/[country]/mobile-app-leave.png',
            alt: "Product screenshot",
        },
        features: [
          {
            name: 'Always Connected',
            description:
              'Acessible 24/7 reflecting the latest data from your colleagues you can rest assured you\'re not working on an expired backup.',
            icon: UserCircleIcon,
          },
          {
            name: 'Payroll from Anywhere',
            description: 'Always wanted that end-of-month holiday but could never do it because of your software? With Buddy all you need is a laptop or tablet and an internet connection.',
            icon: MapPinIcon,
          },
          {
            name: 'Audit Logs',
            description: "Having multiple team members with live-access, may raise questions as to who made changes. Buddy's got your back by keeping a detailed log of all changes made.",
            icon: CheckCircleIcon,
          },
      ]
    },

  {
    "for": "Absences",
    "title": "Holiday Entitlement & Pay",
    backgroundColor: "employer",
    textColor: "employer",
    "description": "Paying for Absences and Holidays can be a nightmare. With customisable Occupational Schemes and statutory calculations, Buddy makes it easy.",
    "image": {
      "src": 'assets/images/[country]/manager-approve-leave.png',
      "alt": "Team leader dashboard screenshot"
    },
    "features": [
      {
        "name": "Holiday Pay",
        "description": "Fully compliant holiday pay calculations. Buddy looks back up to 104 weeks to identify a 52 week reference period.",
        "icon": DevicePhoneMobileIcon
      },
      {
        "name": "Statutory Sick Pay",
        "description": "No more struggles to calculate SSP or occupational sick. Setup your sick schemes and Buddy highlights how each individual day will get paid.",
        "icon": CalendarIcon
      },
      {
        "name": "Involve the Employees & Managers",
        "description": "Holidays and Sick applications can flow right from the employee's mobile app. Once approved by their superiors, Buddy will automatically use this information in the next payroll.",
        "icon": ClockIcon
      }
    ]
  },

  {
    "for": "Time & Attendance",
    "title": "Accurate Payroll Starts with Time",
    backgroundColor: "employer",
    textColor: "employer",
    "description": "As an employer there are a number of obligations that require you to track time. Be it health and safety or minimum wage compliance.",
    "image": {
      "src": 'assets/images/[country]/manager-approve-leave.png',
      "alt": "Management dashboard screenshot"
    },
    "features": [
      {
        "name": "Mobile App",
        "description": "Easily view all your clients, current headcounts and payroll status.",
        "icon": DocumentIcon
      },
      {
        "name": "Punch-Clocks & Data Upload",
        "description": "Buddy connects natively with TimeMoto and ZK Teco cloud-enabled punch clocks. Furthermore we also support a CSV upload facility to allow you to collect the data.",
        "icon": DocumentIcon
      },
      {
        "name": "Integrations",
        "description": "Buddy connects with some of the best T&A software around, including Workforce.com and Deputy. You can view our full list of integrations here.",
        "icon": ChartPieIcon
      },
      {
        "name": "Pay Item Calculations",
        "description": "Once we have time data, Buddy is able to calculate the pay items based on the rules you've set up. Including any night allowances, overtimes and more.",
        "icon": ChartPieIcon
      }
    ]
  },
  {
    "for": "Payroll Calculations",
    "title": "The Right Payroll Software",
    backgroundColor: "employer",
    textColor: "employer",
    "description": "Regardless of whether you have an in-house payroll team or work with an external provider, Buddy will empower them to ensure the numbers are correct each and every time.",
    "image": {
      "src": 'assets/images/[country]/saving-payslip.gif',
      "alt": "Payroll dashboard screenshot"
    },
    "features": [
      {
        "name": "Tax Calculations",
        "description": "Tax, National Insurance, Student Loans, and more. What's even better is that by hovering over the tax, you can see the details computation.",
        "icon": CalculatorIcon
      },
      {
        "name": "Pro-Rated & Split Salaries",
        "description": "Have a mid-month starter? No problem. Buddy calculates their salary based on the days worked. In case of mid-month salary changes we'll also split the payslip into understandable parts.",
        "icon": CalendarIcon
      },
      {
        "name": "Payroll Service Provider Directory",
        "description": "Hundreds of payroll professionals chose Buddy as their payroll software of choice. If all you need is a professional team to take care of your numbers, head to our partner directory.",
        "icon": CalculatorIcon
      },
    ]
  },
  {
    "for": "Work with your Accountant",
    "title": "Collaborate with your Payroll Service Provider",
    backgroundColor: "employer",
    textColor: "employer",
    "description": "Do you struggle with email or phone communication with your accountant or payroll bureau? Why not collaborate on the same tool?",
    "image": {
      "src": 'assets/images/[country]/payroll-client-data.png',
      "alt": "Payroll dashboard screenshot"
    },
    "features": [
      {
        "name": "Payroll Data Entry",
        "description": "Update your employees' details, including salaries on the fly. Then send over any one-off pay items by inserting them right in the platform or by uploading a files into the secure portal.",
        "icon": CalculatorIcon
      },
      {
        "name": "Payroll Approval",
        "description": "Do you find it difficult to approve payroll with all the reports in your inbox? Buddy allows you to easily highlight errors or approve your payroll online without opening tonnes of payslips or excel reports.",
        "icon": CalendarIcon
      },
      {
        "name": "Lifetime Access",
        "description": "Changed Payroll Partner? Buddy will mantain your data until you decide otherwise. This way you can come back and look for any payslips and reports without asking your previous provider.",
        "icon": ClipboardDocumentCheckIcon
      }
    ]
  },
  {
    "for": "Onboarding",
    "title": "Getting Started",
    backgroundColor: "employer",
    textColor: "employer",
    "description": "If you're getting started with your Buddy account we provide a detailed checklist of everything you need before you start payroll. If you're working with a service provider, they will likely do most of the heavy lifting.",
    "image": {
      "src": 'assets/images/[country]/buddy-getting-started.png',
      "alt": "Payroll dashboard screenshot"
    },
    "features": [
      {
        "name": "Employee & Historical Data Import",
        "description": "Buddy Provides a number of CSV, Excel upload facilities alongside imports for FPS and EPS allowing you to add employees and historical items with ease.",
        "icon": CalculatorIcon
      },
      {
        "name": "Onboarding Checklist",
        "description": "Not sure what you need to do? Buddy provides a pre-set list of action items you need to complete to be ready to go.",
        "icon": ClipboardDocumentCheckIcon
      }
    ]
  },
  {
    "for": "Exporting Payroll Data",
    "title": "People & Payroll Reports",
    backgroundColor: "employer",
    textColor: "employer",
    "description": "Reporting is a key part of payroll, required not only to analyse the results of each payroll run but also to verify employee information.",
    "image": {
      "src": 'assets/images/[country]/buddy-reports.png',
      "alt": "Accounting dashboard screenshot"
    },
    "features": [
      {
        "name": "Payroll Report Pack",
        "description": "Buddy provides a standardised payroll report report pack, including PDF copies. This ensures you always have the necessary information your accounts team may ask for without the need of custom reports.",
        "icon": CreditCardIcon
      },
      {
        "name": "Report Builder",
        "description": "We understand that standard and default reports are sometimes not enough. That's why we provide a report builder so you can build your own reports just how you need them.",
        "icon": ChartBarIcon
      },
      {
        "name": "Variance and Change Reports",
        "description": "No payroll report pack would be complete without detailed variance and change reports. Buddy provides these to ensure you can easily identify any discrepancies.",
        "icon": DocumentChartBarIcon
      },
      {
        "name": "Gender Pay Gap",
        "description": "If a business with over 250 people, Buddy helps you create the statutory Gender Pay Gap report",
        "icon": DocumentChartBarIcon
      }
    ]
  },
  {
    "for": "Accounting & Finance",
    "title": "Payroll Journals & Accounting Integrations",
    backgroundColor: "employer",
    textColor: "employer",
    "description": "Once payroll is complete, finance teams start chasing down those final reports so they can start reconciling and allocating their payroll costs.",
    "image": {
      "src": 'assets/images/[country]/accounting-integrations.png',
      "alt": "Accounting dashboard screenshot"
    },
    "features": [
      {
        "name": "Accounting Sync",
        "description": "Direct integrations with Xero & Quickbooks. Sage Online and Freshbooks coming soon.",
        "icon": ChartBarIcon
      },
      {
        "name": "Payroll Payments",
        "description": "Generate XML or Standard 18 BACS files or leverage fintech solutions such as Fyorin or Telleroo for an integrated payment solution.",
        "icon": CreditCardIcon
      },
      {
        "name": "Detailed Journal Entries",
        "description": "Customise your payroll journals with unlimited cost-center drill-downs and customised rules based on Departments roles and even individual staff members.",
        "icon": DocumentChartBarIcon
      }
    ]
  },
  {
    "for": "Data Security",
    "title": "Securing your Payroll Data",
    backgroundColor: "employer",
    textColor: "employer",
    "description": "Payroll data is extremely sensitive, and as custodians of that data we ensure we keep it safe and accessible at any time.",
    "image": {
      "src": 'assets/images/[country]/data-security.gif',
        width: 929,
        height: 519,
      "alt": "IT dashboard screenshot"
    },
    "features": [
      {
        "name": "ISO 27001",
        "description": "This industry leading security certification ensures that the Buddy team has the right security processes in place. This certification is done with external auditors that visit our premises every year. ISO 27001 is more comprehensive when compared to CyberEssentials.",
        "icon": ShieldCheckIconSolid
      },
      {
        "name": "System Penetration Testing",
        "description": "On a regular basis we invite security researches to attempt to hack into our system. This empowers us to stay ahead of hackers and identify potential risks before its too late.",
        "icon": ShieldCheckIconSolid
      },
      {
        "name": "Encryption",
        "description": "All the data you share or store with Buddy is encrypted with AES256-grade encryption both in transit and at rest.",
        "icon": ShieldCheckIconSolid
      },
      {
        "name": "Multi-Factor Authentication",
        "description": "Enable MFA to ensure that your credentials cannot be compromised to access sensitive client data.",
        "icon": CloudIcon
      },
      {
        "name": "UK & EU Data Centres",
        "description": "We leverage AWS's global infrastructure which ensures redundancy with at least 3 geographically distinct data centers per region; and cross-region backups to ensure we are able to recover your data in case of a disaster.",
        "icon": ShieldCheckIconSolid
      },
    ]
  },
  {
    "for": "Cloud Infrastructure",
    "title": "Payroll Power on Demand",
    backgroundColor: "employer",
    textColor: "employer",
    "description": "We understand payroll is mission critical, and that is why we built Buddy on top of AWS, the world's leading cloud provider.",
    "image": {
      "src": 'assets/images/[country]/aws-infrastructure-overview.png',
        width: 929,
        height: 519,
      "alt": "IT dashboard screenshot"
    },
    "features": [
      {
        "name": "On-Demand",
        "description": "Our infrastructure on Amazon ensures that whenever you ask for a calculation or some data, we not only get back in record time, but are not impacted by how many other clients may be using our platform.",
        "icon": ShieldCheckIconSolid
      },
      {
        "name": "Scalability",
        "description": "Regardless of whether you're doing payroll for a director or an enterprise business with thousands of employees we've got you covered.",
        "icon": CloudIcon
      },
      {
        "name": "Innovation",
        "description": "We leverage Amazon's continued innovation with use of AI and the latest cloud technology enables us to do.",
        "icon": ShieldCheckIconSolid
      },
    ]
  },
  {
    "for": "Stellar Support",
    "title": "Getting Help when you need it",
    backgroundColor: "employer",
    textColor: "employer",
    "description": "Every payroll software is as good, or bad as it's customer success team. That's why we've invested heavily to ensure you get nothing but the best.",
    "image": {
      "src": 'assets/images/[country]/manager-approve-leave.png',
      "alt": "Management dashboard screenshot"
    },
    "features": [
      {
        "name": "Live Chat",
        "description": "Available every week day during business hours 9:00 to 17:00. Our human agents have maintained an average response time of under 20 seconds over the last 12 months.",
        "icon": DocumentIcon
      },
      {
        "name": "Detailed Support Articles",
        "description": "Looking for support out of hours? That's where our support bot will guide you to pre-existing detialed artilces to get you unstuck. If that doesn't work, leave a message for us to view on the next business day.",
        "icon": DocumentIcon
      },
      {
        "name": "Ticket History",
        "description": "Lost in emails and you need to check a previous response? We provide detailed ticket history that can be shared with your team, so you never lose another reponse.",
        "icon": DocumentIcon
      },
      {
        "name": "Amazing Humans",
        "description": "While Generative AI is taking over the world, we don't yet trust it to ensure that your payroll is correct. That's why we have a team of amazing humans that respond to every query.",
        "icon": ChartPieIcon
      }
    ]
  }
]

function UkLanding({
    contactInList,
    saveLead,
    profile,
}) {

    const location = useLocation()

    const countryCode = location.pathname.split('/')[1]
    const country = ['uk', 'mt', 'ie'].includes(countryCode) ? countryCode: null

    console.log('country',country)
    console.log('location.pathname.split',location.pathname.split('/'))

    const {
        emailList,
        tags
    } = useMemo(() => {

        let emailList = 11
        let tags = {
            ukSignUp: 56
        }

        switch (country){
            case 'uk': {
                emailList = 11
                tags = {
                    ukSignUp: 56
                }
            }
        }

        return {
            emailList,
            tags
        }

    },[country]);

    useEffect(() => {
        // load initial data required for anywhere
        if (profile && profile.email && emailList) {
            contactInList({
                email: profile.email,
                list: emailList
            })
        }
    }, [profile && profile.email,emailList]);


    return (

        <React.Fragment>

            <SeoHeaders
                country={country}
                title={title}
                description={intro}
            />

            <main className="pt-8 sm:pt-16 md:pt-20 lg:pb-24 pb-8 sm:pb-16 md:pb-20 lg:pb-24 bg-employer-900">
                <div className="mx-auto max-w-screen-xl">
                    <div className="lg:grid lg:grid-cols-12 lg:gap-8">
                        <div className="px-4 sm:px-6 sm:text-center md:max-w-2xl md:mx-auto lg:col-span-6 lg:text-left lg:flex lg:items-center">
                            <div>
                                <h1 className="mt-4 text-4xl tracking-tight leading-10 font-extrabold text-white sm:mt-5 sm:leading-none sm:text-6xl lg:mt-6 lg:text-5xl xl:text-6xl">
                                    <span>Cloud Payroll & HR Software</span>
                                    <br />
                                    <span className="text-orange-400">for Employers</span>
                                </h1>
                                <p className="mt-3 text-base text-gray-300 sm:mt-5 lg:text-lg">
                                    {intro}
                                </p>

                                  <div className="mt-10 flex gap-x-6">
                                    <a href="#" className="text-sm font-semibold leading-6 text-white">
                                        {introCta} <span aria-hidden="true">↓</span>
                                    </a>
                                  </div>
                            </div>
                        </div>
                        {<div className="mt-12 sm:mt-16 lg:mt-0 lg:col-span-6" id={"leadForm"}>
                            <RegistrationForm list={emailList} jurisdiction={country?.toUpperCase()} />
                        </div>}
                    </div>
                </div>
            </main>


            {/*<div class="bg-white py-24 sm:py-32">
              <div class="mx-auto max-w-7xl px-6 lg:px-8">
                <div class="mx-auto max-w-2xl lg:text-center">
                  <p class="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">Buddy: Your Comprehensive Payroll Companion</p>
                  <p class="mt-6 text-lg leading-8 text-gray-600">In the world of payroll, details matter. But so do people. At Buddy, we've crafted a solution that balances both, ensuring that every stakeholder, from employees to IT teams, feels valued and empowered. Our platform isn't just about numbers; it's about nurturing relationships, streamlining processes, and building trust. Dive in to discover how Buddy becomes an integral part of your team, simplifying complexities and amplifying efficiencies.</p>

                  <h2 class="mt-12 text-lg font-semibold leading-7 text-orange-600">Why Buddy?</h2>
                </div>
                <div class="mx-auto mt-10 max-w-2xl sm:mt-20 lg:mt-20 lg:max-w-4xl">
                  <dl class="grid max-w-xl grid-cols-1 gap-x-8 gap-y-10 lg:max-w-none lg:grid-cols-2 lg:gap-y-16">
                      {painpoints.map((feature) => (
                            <div key={feature.name}  class="relative pl-16">
                              <dt class="text-base font-semibold leading-7 text-gray-900">
                                <div class="absolute left-0 top-0 flex h-10 w-10 items-center justify-center rounded-lg bg-orange-600">

                                    {feature.icon}

                                </div>
                                {feature.name}
                              </dt>
                              <dd class="mt-2 text-base leading-7 text-gray-600">{feature.description}</dd>
                            </div>

                        ))}
                  </dl>
                </div>
                <div class="mx-auto mt-12 max-w-2xl lg:text-center">
                    <h2 className="text-lg font-extrabold text-gray-900">Every organization is a complex web of interactions, decisions, and processes. See how Buddy seamlessly fits into each facet, enhancing productivity and ensuring satisfaction.</h2>
                </div>
              </div>
            </div>*/}

            {forBlocks.map((block,index) => (
                index % 2 !== 0 ? <DarkScreenshotRight key={block.for} content={block}  country={country}/> : <LightScreenshotLeft key={block.for} content={block}  country={country}/>
            ))}

            <div className="bg-orange-600">
                <div className="max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:px-8">
                    <div className="bg-white shadow-xl rounded-lg overflow-hidden lg:grid lg:grid-cols-2 lg:gap-4">
                        <div className="pt-10 pb-12 px-6 sm:pt-16 sm:px-16 lg:py-16 lg:pr-0 xl:py-20 xl:px-20">
                            <div className="lg:self-center">
                                <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl">
                                    <span className="block">Discover, Buddy</span>
                                    <span className="block">Your new Payroll Companion</span>
                                </h2>
                                <p className="mt-4 text-lg leading-6 text-gray-900">
                                    Buddy does all the heavy lifting, so you can spend as little time as possible on your payroll, knowing that everything’s just how it should be.
                                </p>
                                <NavHashLink to="#leadForm"
                                    className="mt-8 bg-orange-600 border border-transparent rounded-md shadow px-5 py-3 inline-flex items-center text-base font-medium text-white hover:bg-orange-50"
                                >
                                    Discover Buddy
                                </NavHashLink>
                            </div>
                        </div>
                        <div className="-mt-6 aspect-w-5 aspect-h-3 md:aspect-w-2 md:aspect-h-1">
                            <img
                                className="transform translate-x-6 translate-y-6 rounded-md object-cover object-left-top sm:translate-x-16 lg:translate-y-20"
                                src={appScreenshot}
                                alt="App screenshot"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className="bg-gray-50">
                <div className="max-w-7xl mx-auto py-12 px-4 sm:py-16 sm:px-6 lg:px-8">
                    <div className="max-w-4xl mx-auto divide-y-2 divide-gray-200">
                        <h2 className="text-center text-3xl font-extrabold text-gray-900 sm:text-4xl">Frequently asked questions</h2>
                        <dl className="space-y-16 sm:grid sm:grid-cols-2 sm:gap-x-6 sm:gap-y-6 sm:space-y-0 lg:gap-x-10 pt-6">
                            {faqs.map((faq) => (
                                <Disclosure as="div" key={faq.question}>
                                    {({ open }) => (
                                        <>
                                            <dt className="text-md">
                                                <Disclosure.Button className="text-left w-full flex justify-between items-start text-gray-400">
                                                    <span className="font-medium text-gray-900">{faq.question}</span>
                                                    <span className="ml-6 h-7 flex items-center">
                                                        <ChevronDownIcon
                                                            className={classNames(open ? '-rotate-180' : 'rotate-0', 'h-6 w-6 transform')}
                                                            aria-hidden="true"
                                                        />
                                                    </span>
                                                </Disclosure.Button>
                                            </dt>
                                            <Disclosure.Panel as="dd" className="mt-2 pr-12">
                                                <p className="text-sm text-gray-500">{faq.answer}</p>
                                            </Disclosure.Panel>
                                        </>
                                    )}
                                </Disclosure>
                            ))}
                        </dl>
                    </div>
                </div>
            </div>

            <Team />

            {/*<div className="bg-orange-600">
                <div className="max-w-2xl mx-auto text-center py-16 px-4 sm:py-20 sm:px-6 lg:px-8">
                    <h2 className="text-3xl leading-9 font-extrabold text-white sm:text-4xl sm:leading-10">
                        <span className="block">It's time to place yourself first.</span>
                        <span className="block">Book a spot to discover how.</span>
                    </h2>
                    <a target="_blank" href="https://calendly.com/buddy-intro/uk" className="mt-8 w-full inline-flex items-center justify-center px-5 py-3 border border-transparent text-base leading-6 font-medium rounded-md text-orange-600 bg-white hover:text-orange-500 hover:bg-orange-50 transition duration-150 ease-in-out sm:w-auto">
                        Book my spot
                    </a>
                    <p className="mt-4 text-xs leading-1 text-orange-200">We'll take 15min of your time to understand if you're someone our payroll solution can help. <br /> This is a no-commitment call and comes at no charge.</p>
                </div>
            </div>*/}


        </React.Fragment>

    );
}

const mapStateToProps = (state) => {

    // const {
    //   myAgreements,
    // } = state.my

    const profile = state && state.my && state.my.profile || localStorage.getItem('userData') && JSON.parse(localStorage.getItem('userData'))

    const userInList = state.createAccount && state.createAccount.inList && state.createAccount.inList

    return {
        userInList,
        profile
        // showSidebar: state.sidebar.show,
        // loggedIn: state.my.profile ? true : false,
    }
}

const mapDispatchToProps = dispatch => ({
    contactInList: (data) => dispatch(CREATEACCOUNTACTIONS.contactInList(data)),
    saveLead: (data) => dispatch(CREATEACCOUNTACTIONS.saveLead(data)),
    addTag: (data) => dispatch(CREATEACCOUNTACTIONS.addTag(data)),
    setWebinar: (webinar) => dispatch(WEBINARACTIONS.setWebinar(webinar)),
    // getProfile: () => dispatch(MYACTIONS.getProfile()),
    // isLoggedIn: () => dispatch(AUTHENTICATIONACTIONS.isLoggedIn()),
    // getDepartments: () => dispatch(TEAMACTIONS.getDepartments()),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UkLanding)